type IconProps = {
  selected?: boolean;
  highlighted?: boolean;
  none?: boolean;
  pressed?: boolean;
};

export default function NewScanIcon({ selected, highlighted, none, pressed }: IconProps) {
  if (highlighted) {
    return (
      <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14 19V17C14 16.2044 14.3163 15.4415 14.8789 14.8789C15.4415 14.3163 16.2044 14 17 14H19C19.5523 14 20 14.4477 20 15C20 15.5523 19.5523 16 19 16H17C16.7348 16 16.4805 16.1054 16.293 16.293C16.1054 16.4805 16 16.7348 16 17V19C16 19.5523 15.5523 20 15 20C14.4477 20 14 19.5523 14 19Z"
          fill="#EAEEF5"
          strokeWidth={pressed ? '1' : '0'}
          stroke="#EAEEF5"
        />
        <path
          d="M32 19V17C32 16.7348 31.8946 16.4805 31.707 16.293C31.5429 16.1288 31.3276 16.0276 31.0986 16.0049L31 16H29C28.4477 16 28 15.5523 28 15C28 14.4477 28.4477 14 29 14H31C31.7956 14 32.5585 14.3163 33.1211 14.8789C33.6837 15.4415 34 16.2044 34 17V19C34 19.5523 33.5523 20 33 20C32.4477 20 32 19.5523 32 19Z"
          fill="#EAEEF5"
          strokeWidth={pressed ? '1' : '0'}
          stroke="#EAEEF5"
        />
        <path
          d="M32 31V29C32 28.4477 32.4477 28 33 28C33.5523 28 34 28.4477 34 29V31C34 31.7957 33.6837 32.5585 33.1211 33.1211C32.5585 33.6837 31.7957 34 31 34H29C28.4477 34 28 33.5523 28 33C28 32.4477 28.4477 32 29 32H31C31.2652 32 31.5195 31.8946 31.707 31.707C31.8946 31.5195 32 31.2652 32 31Z"
          fill="#EAEEF5"
          strokeWidth={pressed ? '1' : '0'}
          stroke="#EAEEF5"
        />
        <path
          d="M14 31V29C14 28.4477 14.4477 28 15 28C15.5523 28 16 28.4477 16 29V31L16.0049 31.0986C16.0276 31.3276 16.1288 31.5429 16.293 31.707C16.4805 31.8946 16.7348 32 17 32H19C19.5523 32 20 32.4477 20 33C20 33.5523 19.5523 34 19 34H17C16.2044 34 15.4415 33.6837 14.8789 33.1211C14.3163 32.5585 14 31.7956 14 31Z"
          fill="#EAEEF5"
          strokeWidth={pressed ? '1' : '0'}
          stroke="#EAEEF5"
        />
        <path
          d="M29 23C29.5523 23 30 23.4477 30 24C30 24.5523 29.5523 25 29 25H19C18.4477 25 18 24.5523 18 24C18 23.4477 18.4477 23 19 23H29Z"
          fill="#EAEEF5"
          strokeWidth={pressed ? '1' : '0'}
          stroke="#EAEEF5"
        />
      </svg>
    );
  }
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14 19V17C14 16.2044 14.3163 15.4415 14.8789 14.8789C15.4415 14.3163 16.2044 14 17 14H19C19.5523 14 20 14.4477 20 15C20 15.5523 19.5523 16 19 16H17C16.7348 16 16.4805 16.1054 16.293 16.293C16.1054 16.4805 16 16.7348 16 17V19C16 19.5523 15.5523 20 15 20C14.4477 20 14 19.5523 14 19Z"
        fill="#112645"
      />
      <path
        d="M32 19V17C32 16.7348 31.8946 16.4805 31.707 16.293C31.5429 16.1288 31.3276 16.0276 31.0986 16.0049L31 16H29C28.4477 16 28 15.5523 28 15C28 14.4477 28.4477 14 29 14H31C31.7956 14 32.5585 14.3163 33.1211 14.8789C33.6837 15.4415 34 16.2044 34 17V19C34 19.5523 33.5523 20 33 20C32.4477 20 32 19.5523 32 19Z"
        fill="#112645"
      />
      <path
        d="M32 31V29C32 28.4477 32.4477 28 33 28C33.5523 28 34 28.4477 34 29V31C34 31.7957 33.6837 32.5585 33.1211 33.1211C32.5585 33.6837 31.7957 34 31 34H29C28.4477 34 28 33.5523 28 33C28 32.4477 28.4477 32 29 32H31C31.2652 32 31.5195 31.8946 31.707 31.707C31.8946 31.5195 32 31.2652 32 31Z"
        fill="#112645"
      />
      <path
        d="M14 31V29C14 28.4477 14.4477 28 15 28C15.5523 28 16 28.4477 16 29V31L16.0049 31.0986C16.0276 31.3276 16.1288 31.5429 16.293 31.707C16.4805 31.8946 16.7348 32 17 32H19C19.5523 32 20 32.4477 20 33C20 33.5523 19.5523 34 19 34H17C16.2044 34 15.4415 33.6837 14.8789 33.1211C14.3163 32.5585 14 31.7956 14 31Z"
        fill="#112645"
      />
      <path
        d="M29 23C29.5523 23 30 23.4477 30 24C30 24.5523 29.5523 25 29 25H19C18.4477 25 18 24.5523 18 24C18 23.4477 18.4477 23 19 23H29Z"
        fill="#112645"
      />
    </svg>
  );
}
